<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <h3>Kiekybinio atstovavimo taisyklės</h3>
      </v-col>

      <v-col cols="12">
        <el-checkbox
          class="my-0"
          style="width: fit-content;"
          label="Kiekybinio atstovavimo taisyklė taikoma"
          v-model="isQuantitativeRuleOnComputed"
        />
      </v-col>

      <v-col cols="12">
        <v-card
          v-for="(katRule, index) in katRules"
          :key="index"
          class="mb-2 bg-white border"
        >
          <v-card-text class="white d-flex justify-space-between">
            <div>
              {{ `${katRule.kat_id}. ${katRule.title_lt}` }}
            </div>
            <div>
              <v-icon v-if="!expandedRules.includes(katRule.kat_id)" @click="showFacts(katRule.kat_id)">mdi-chevron-right</v-icon>
              <v-icon v-else @click="hideFacts(katRule.kat_id)">mdi-chevron-down</v-icon>
            </div>
          </v-card-text>
          <v-card-text class="px-0 py-0" v-if="expandedRules.includes(katRule.kat_id)">
            <v-data-table
              class="mb-4 custom-table sticky-header"
              :loading="loading"
              :headers="headers"
              :items="katRule.facts"
              :hide-default-footer="true"
              disable-pagination
            >
              <!-- basic templates -->
              <template slot="loading"> {{ $t('Kraunasi...') }} </template>
              <template slot="no-results"> {{ $t('Duomenų nėra') }} </template>
              <template slot="no-data"> {{ $t('Duomenų nėra') }} </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  components: {  },
  name: 'SigningPersonRuleQuantativeForm',
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      loading: false,
      selectedForms: [],
      itemsPerPageOptions: [10, 50, 100],
      expandedRules: [],
      pagination: {
        page: 1,
        pageSize: 100,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
    }
  },
  props: {
    katRules: Array,
    isQuantitativeRuleOn: Boolean,
  },
  computed: {
    isQuantitativeRuleOnComputed: {
      get() {
        return this.isQuantitativeRuleOn
      },
      set(value) {
        this.$emit('update:isQuantitativeRuleOn', value)
      }
    },
    headers() {
      return [
        {
          text: this.$t('KAT_ID'),
          sortable: false,
          align: 'start',
          value: 'kat_id',
        },
        {
          text: this.$t('Pavadinimas'),
          sortable: false,
          align: 'start',
          value: 'fact_title_lt',
        },
        {
          text: this.$t('FAKTO_TIPAS'),
          sortable: false,
          align: 'start',
          value: 'fact_type_code',
        },
        {
          text: this.$t('FAKTO_POTIPIS'),
          sortable: false,
          align: 'start',
          value: 'fact_sub_type_code',
        },
        {
          text: this.$t('Privalomi'),
          sortable: false,
          align: 'start',
          value: 'mandatory',
        },
      ]
    },
  },
  methods: {
    hideFacts(formCode) {
      this.expandedRules = this.expandedRules.filter(item => item !== formCode)
    },
    showFacts(formCode) {
      this.expandedRules.push(formCode)
    }
  },
}
</script>
